import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { OtherApiService } from 'src/app/Services/other.service';

@Component({
  selector: 'app-excel-template-filter',
  templateUrl: './excelTemplateFilter.component.html',
  styleUrls: ['./excelTemplateFilter.component.scss']
})
export class ExcelTemplateFilterComponent implements OnInit {
  permissions = localStorage.getItem('permissions');
  @Input() viewNames
  @Input() selectedItem
  // @Input() hasError
  @Output() selectedExcelTemplate = new EventEmitter<any>();
  @Output() viewSelectedExcelTemplate = new EventEmitter<any>();

  primaryColour: string;
  constructor(private service2: OtherApiService,) { }

  ngOnInit() {
    this.primaryColour = this.service2.passColour()	
  }

  onSelectedExcel()
  {
    this.selectedExcelTemplate.emit()
  }
  viewExcelTemplate(item)
  {
    this.viewSelectedExcelTemplate.emit(item)
  }
  checkPermission(value){
    if(this.permissions.includes(value)){
      return true;
    }else{
      return false;
    }
  }
}
